import React from 'react';
import omit from 'lodash/omit';
import {
  Field,
  FastField,
  useFormikContext,
  useField,
} from 'formik';

import FieldQuill from './FieldQuill.jsx';
import FieldSummernote from './FieldSummernote.jsx';
import FieldFileCoverImg from './FieldFileCoverImg.jsx';
import FieldFileSlider from './FieldFileSlider.jsx';
import FieldFileSliderObj from './FieldFileSliderObj.jsx';

const FormField = (props) => {
  const {
    name,
    affirm,
    as,
  } = props;
  const {
    validateOnMount,
  } = useFormikContext();
  const [, { error, touched }] = useField(name);

  if (!validateOnMount && affirm) {
    console.error('"validateOnMount" is necessary for the "affirm" property');
  }

  // get className
  const c = [
    as === 'select' ? 'custom-select' : 'form-control',
    props.className,
    error && touched ? 'is-invalid' : '',
  ];

  if (touched && error) {
    c.push('is-invalid');
  }
  if (affirm && !error) {
    c.push('is-valid');
  }

  const className = c.filter((s) => s).join(' ');
  const p = {
    ...omit(props, ['affirm']),
    className,
  };

  if (as === 'quill') {
    return <FieldQuill {...p} />;
  }
  if (as === 'summernote') {
    return <FieldSummernote {...p} />;
  }
  if (as === 'coverImg') {
    return <FieldFileCoverImg {...p} />;
  }
  if (as === 'slider') {
    return <FieldFileSlider {...p} />;
  }
  if (as === 'objSlider') {
    return <FieldFileSliderObj {...p} />;
  }
  if (as === 'display') {
    return <FastField {...{ name, className, disabled: true }} />;
  }

  return <Field {...p} />;
};

export default FormField;
